import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { DetailBadge } from '../detail_badge/detail_badge';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-classifiche',
  templateUrl: 'classifiche.html',
})
export class ClassifichePage extends Util {
  pagine: any;
  user: any;
  mjl: any;
  page: string;
  percent_hat = '20%';
  itemExpandHeight = 250;
  refresh_dashboard: boolean = false;
  @ViewChild('primaclassifica') primaclassifica: ElementRef;
  @ViewChild('secondaclassifica') secondaclassifica;
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    this.user = this.navParams.get('user');
    // console.log(this.gs.myuser);
    this.refreshpage();
  }
  refreshpage() {
    this.GetRequest('campionati', '').then(data => {
      // console.log(data);
      this.mjl = data['CampionatoList'];

      // this.mjl = data['MicroJourneyList'];

      for (let i = 0; i < this.mjl.length; i++) {
        this.mjl[i].arr_expand = false;
        this.mjl[i].badge = [];
        this.mjl[i].data = {};
      }

      // console.log(this.mjl);
    }).catch((e) => {
      console.error(e)
    })
  }

  back() {
    if (this.refresh_dashboard == false)
      this.navCtrl.pop({ animate: false });
    else
      this.go_root();
  }
  open_badge(i) {

    if (i.arr_expand == false) {
      this.GetRequest('classificheCampionato', i.id).then(data => {
        // i.classifica_squadra = data['classifica_squadra'];
        // i.classifica_squadre = data['classifica_squadre'];
        // i.str_header = data['str_header'];
        // i.perc = data['perc'];
        i.data = data;

        // for(var f = 0; f < i.data.classifica_squadra.length;f++){
        //   console.log(i.data.classifica_squadre[f]);

        //   if(f == 0)
        //     i.data.classifica_squadre[f].isMine = true;
        // }
        // console.log(all_my);
        // console.log(all_my['offsetTop']);
        // console.log(data);
        setTimeout(() => {
          let all_my = document.getElementById('itemmjl' + i.id).getElementsByClassName('my');
          let scroll_table = document.getElementById('itemmjl' + i.id).getElementsByClassName('classifica_scroll');
          let offset = 0;
          let set_table = scroll_table[0];
          for (var j = 0; j < all_my.length; j++) {
            offset = all_my[0]['offsetTop'];
            break;
          }
          set_table.scrollTop = offset-100;

          let all_mys = document.getElementById('itemmjls' + i.id).getElementsByClassName('my');
          let scroll_tables = document.getElementById('itemmjls' + i.id).getElementsByClassName('classifica_scroll');
          let set_tables = scroll_tables[0];
          let offsets = 0;
         
          for (var j = 0; j < all_mys.length; j++) {
            
            offsets = all_mys[0]['offsetTop'];
            break;
          }
          set_tables.scrollTop = offsets-100;

          // this.primaclassifica.nativeElement.scrollTop = offset;
          // this.secondaclassifica.nativeElement.scrollTop = offsets;
        }, 1000);
        for (let y = 0; y < this.mjl.length; y++) {
          this.mjl[y].arr_expand = false;
        }
        i.arr_expand = true;

      }).catch((e) => {
        //this.navCtrl.push(Mj_Detail,{mj:m});
        console.error(e)
      })

    }

    else
      i.arr_expand = false;


  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }
  // reset_badge(item) {
  //   // console.log(item);
  //   this.presentPopover(event, Confirm, 'Stai per azzerare questo percorso: i tuoi progressi e i badge che hai raccolto verranno cancellati e tutte le statistiche saranno azzerate, con la sola esclusione del tempo di allenamento complessivo, vuoi procedere?').then((data) => {
  //     // console.log(data);
  //     if (data == 'confirm') {
  //       this.presentPopover(event, Confirm, 'Una volta data conferma i dati del percorso "'+item.nome+'" verranno definitivamente cancellati e non sarà più possibile recuperarli in alcun modo. Sei certo di voler azzerare questo percorso?', 'danger').then((data_) => {
  //         if (data_ == 'confirm') {
  //           this.PostRequest('resetMJ', item.id, {}, true, true).then(data_x => {
  //             this.refresh_dashboard = true; 
  //             // console.log(data_x);
  //             item.arr_expand = false;
  //           }).catch((e) => {
  //             //this.navCtrl.push(Mj_Detail,{mj:m});
  //             console.error(e)
  //           })
  //         }
  //       });
  //     }
  //   });


  // }
  show_detail_badge(b) {
    this.presentPopover(event, DetailBadge, b).then((data_) => {

    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/classifiche/classifiche.ts